// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__39wi1","header":"Messages_header__2t0nZ"};